import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useBasicBenefitsChartsDataContext } from './hooks/useBasicBenefitsChartsDataContext';
import { getMonthLabel } from '../../../Common/Util/getMonthLabel';

export const AverageValuePerMonth = () => {
    const { chartData } = useBasicBenefitsChartsDataContext();

    const rawData = chartData.averageValues.monthly;

    const series = [
        {
            name: 'Valor Médio por Família',
            data: rawData.map(item => Number(item.value))
        }
    ];

    const isYearComparison =
        rawData.length > 0 &&
        rawData.every(item => item.mes === rawData[0].mes);

    const formattedSubtitles = isYearComparison
        ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`)
        : rawData.map(item => getMonthLabel(item.mes));

    return (
        <SimpleBars
            title="Valor Médio por Família - Mensal"
            horizontal={false}
            subtitles={formattedSubtitles}
            series={series}
        />
    );
};
